var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcticonsEmojiWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_451_792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00801 8.85409C7.13613 8.85409 8.85384 7.12804 8.85384 4.99159C8.85384 2.86346 7.13613 1.14575 5.00801 1.14575M5.00801 8.85409C2.87155 8.85409 1.14551 7.12804 1.14551 4.99159C1.14551 2.86346 2.87155 1.14575 5.00801 1.14575M5.00801 8.85409V1.14575M8.34384 3.07284H1.65801M8.3653 6.88013H1.63655M1.16634 4.99992H8.83301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00449 8.85409C6.06866 8.85409 6.92741 7.12804 6.92741 4.99159C6.92741 2.86346 6.06866 1.14575 5.00449 1.14575C3.93616 1.14575 3.07324 2.86346 3.07324 4.99159C3.07324 7.12804 3.93616 8.85409 5.00449 8.85409Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_451_792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticonsEmojiWeb);
export default __webpack_public_path__ + "static/media/arcticons_emoji-web.5a23d5e93e7378103922d6163d70a85d.svg";
export { ForwardRef as ReactComponent };